import { render, staticRenderFns } from "./FirmLicenseDetails.vue?vue&type=template&id=1b714e2e&scoped=true&"
import script from "./FirmLicenseDetails.vue?vue&type=script&lang=js&"
export * from "./FirmLicenseDetails.vue?vue&type=script&lang=js&"
import style0 from "./FirmLicenseDetails.vue?vue&type=style&index=0&id=1b714e2e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b714e2e",
  null
  
)

export default component.exports